var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSportMarketingFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_653_921)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.511 133.942L102.797 150.666",
    stroke: "#7DD351",
    strokeWidth: 1.95792,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.545 136.311L144.648 153.28",
    stroke: "#7DD351",
    strokeWidth: 1.95792,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.3398 138.92C88.0319 145.12 101 154.289 124.009 155.481C149.217 156.786 157.973 148.846 160.719 145.446",
    stroke: "#7DD351",
    strokeWidth: 3.26318,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.849 165.193C183.914 168.129 187.82 176.108 186.906 184.526",
    stroke: "#7DD351",
    strokeWidth: 3.26318,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.722 148.387C190.414 149.529 195.913 153.282 196.37 159.155",
    stroke: "#7DD351",
    strokeWidth: 3.26318,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.119 109.718C105.082 110.207 92.9266 112.948 92.6003 119.997C92.2738 127.045 109.542 131.581 118.216 132.968",
    stroke: "#7DD351",
    strokeWidth: 2.12107,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.614 133.374C141.14 133.456 155.025 131.547 158.353 123.259",
    stroke: "#7DD351",
    strokeWidth: 2.12107,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.043 11.904C105.196 8.05345 108.78 10.5172 110.303 12.2303C112.587 8.24925 116.259 8.88557 117.319 10.5987C119.864 15.7546 113.158 21.3401 109.488 23.4883C106.442 21.2313 100.889 15.7546 103.043 11.904Z",
    fill: "#7DD351"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8295 143.278C10.8179 139.783 14.341 139.107 16.229 139.206C15.2165 135.559 17.7176 133.773 19.3375 134.143C23.8385 135.638 23.2301 142.811 22.3632 146.21C19.2734 146.689 12.8411 146.774 11.8295 143.278Z",
    fill: "#7DD351"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.8963 24.6014C91.2062 21.4949 92.1934 12.0634 93.4894 6.12995C93.7536 4.92038 94.8738 4.11687 96.1099 4.18713L124.158 5.78162C125.033 5.83133 125.84 6.30931 126.197 7.10909C128.961 13.3041 127.234 21.8773 125.522 26.8588C125.142 27.9641 124.023 28.6058 122.863 28.4644L116.442 27.6813C115.434 27.5585 114.447 28.031 113.91 28.8929L110.071 35.059C109.791 35.508 109.122 35.4555 108.916 34.9683L105.755 27.4933C105.39 26.6278 104.587 26.0257 103.653 25.9169L95.9622 25.0195C95.575 24.9743 95.1946 24.8525 94.8963 24.6014Z",
    stroke: "#7DD351",
    strokeWidth: 3.10003,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0565 155.419C10.0947 155.784 5.13168 149.739 2.40069 145.54C1.84396 144.683 2.0216 143.56 2.77927 142.876L19.971 127.339C20.507 126.855 21.2555 126.658 21.9316 126.912C27.169 128.88 31.1995 134.863 33.1308 138.754C33.5593 139.618 33.2876 140.646 32.5322 141.245L28.3514 144.56C27.6952 145.08 27.4001 145.933 27.5949 146.748L28.9885 152.575C29.09 152.999 28.6709 153.361 28.2656 153.2L22.0473 150.722C21.3273 150.435 20.5087 150.558 19.9038 151.042L14.9196 155.036C14.6687 155.237 14.3767 155.39 14.0565 155.419Z",
    stroke: "#7DD351",
    strokeWidth: 2.55695,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7758 101.264C96.5578 100.731 95.6291 98.0051 93.7016 95.1749C91.774 92.3448 89.5775 90.4823 88.7955 91.0149C88.0135 91.5475 88.9421 94.2735 90.8697 97.1037C92.7972 99.9338 94.9937 101.796 95.7758 101.264Z",
    fill: "#7DD351"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.618 126.447C168.7 127.39 172.119 127.861 176.253 127.5C180.387 127.139 183.672 126.083 183.59 125.14C183.508 124.197 180.089 123.726 175.955 124.087C171.821 124.448 168.536 125.504 168.618 126.447Z",
    fill: "#7DD351"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.734 138.877C166.521 139.799 169.626 141.305 173.669 142.24C177.712 143.176 181.163 143.187 181.376 142.265C181.59 141.343 178.485 139.838 174.441 138.902C170.398 137.967 166.947 137.956 166.734 138.877Z",
    fill: "#7DD351"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.351 99.1718C108.473 98.7105 107.339 93.3662 104.818 87.2351C102.296 81.104 99.343 76.5077 98.2211 76.9691C97.0991 77.4304 98.2334 82.7747 100.755 88.9058C103.276 95.0369 106.229 99.6332 107.351 99.1718Z",
    fill: "#7DD351"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.974 99.2463C136.119 99.6468 139.317 93.4805 142.118 85.4736C144.918 77.4666 146.26 70.6511 145.115 70.2506C143.97 69.8501 140.771 76.0163 137.971 84.0233C135.17 92.0302 133.829 98.8458 134.974 99.2463Z",
    fill: "#7DD351"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.961 113.178C164.447 114.29 171.142 112.438 178.915 109.041C186.688 105.645 192.595 101.991 192.109 100.879C191.624 99.7674 184.929 101.619 177.156 105.016C169.383 108.412 163.475 112.066 163.961 113.178Z",
    fill: "#7DD351"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.676 191.014C140.852 190.715 140.107 183.808 138.013 175.588C135.919 167.368 133.268 160.947 132.093 161.247C130.917 161.546 131.662 168.453 133.756 176.673C135.85 184.893 138.501 191.314 139.676 191.014Z",
    fill: "#7DD351"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.575 183.875C113.77 184.087 115.718 178.756 116.926 171.966C118.135 165.177 118.146 159.501 116.952 159.288C115.758 159.076 113.81 164.407 112.601 171.196C111.393 177.986 111.381 183.662 112.575 183.875Z",
    fill: "#7DD351"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8023 176.338C85.722 177.13 90.1131 173.533 94.6101 168.305C99.1071 163.077 102.007 158.197 101.087 157.406C100.168 156.615 95.7766 160.212 91.2796 165.44C86.7826 170.668 83.8826 175.547 84.8023 176.338Z",
    fill: "#7DD351"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3216 162.568C70.9933 163.579 75.615 161.686 80.6443 158.341C85.6736 154.997 89.2061 151.466 88.5344 150.456C87.8626 149.446 83.2409 151.339 78.2116 154.683C73.1823 158.028 69.6498 161.558 70.3216 162.568Z",
    fill: "#7DD351"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.704 160.187C143.701 160.87 145.645 165.47 149.045 170.462C152.445 175.454 156.014 178.947 157.017 178.265C158.02 177.582 156.076 172.981 152.676 167.989C149.276 162.997 145.706 159.504 144.704 160.187Z",
    fill: "#7DD351"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.725 103.24C151.616 104.193 158.799 98.9238 166.767 91.4709C174.736 84.018 180.473 77.2036 179.582 76.2505C178.69 75.2975 171.508 80.5667 163.539 88.0196C155.571 95.4725 149.833 102.287 150.725 103.24Z",
    fill: "#7DD351"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.847 97.7973C120.047 97.6221 119.722 88.5857 118.121 77.6139C116.519 66.6422 114.248 57.8899 113.048 58.0651C111.847 58.2403 112.172 67.2767 113.774 78.2484C115.375 89.2202 117.646 97.9725 118.847 97.7973Z",
    fill: "#7DD351"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0577 77.9767C49.4094 77.9767 50.5051 76.881 50.5051 75.5293C50.5051 74.1776 49.4094 73.0819 48.0577 73.0819C46.7061 73.0819 45.6104 74.1776 45.6104 75.5293C45.6104 76.881 46.7061 77.9767 48.0577 77.9767Z",
    fill: "#7DD351"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3785 74.8794C57.7302 74.8794 58.8259 73.7837 58.8259 72.432C58.8259 71.0803 57.7302 69.9846 56.3785 69.9846C55.0269 69.9846 53.9312 71.0803 53.9312 72.432C53.9312 73.7837 55.0269 74.8794 56.3785 74.8794Z",
    fill: "#7DD351"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8629 72.4307C66.2146 72.4307 67.3103 71.3349 67.3103 69.9833C67.3103 68.6316 66.2146 67.5359 64.8629 67.5359C63.5113 67.5359 62.4155 68.6316 62.4155 69.9833C62.4155 71.3349 63.5113 72.4307 64.8629 72.4307Z",
    fill: "#7DD351"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7355 54.1493C56.0541 56.8808 40.2269 63.8923 33.1102 67.6598C32.3941 68.0388 31.896 68.7351 31.9182 69.5448C32.0545 74.5094 36.1543 83.1554 39.0273 88.3825C39.6193 89.4595 40.8964 89.94 42.0647 89.5586L54.6699 85.4427C55.5293 85.1619 56.4727 85.3459 57.1637 85.929L62.9038 90.7723C64.469 92.0929 66.876 91.1793 67.1707 89.1528L68.2353 81.8341C68.3695 80.9105 68.987 80.1287 69.8544 79.784L79.3553 76.0079C80.4354 75.5786 81.1093 74.4854 80.9468 73.3345C79.7401 64.7969 76.3175 58.2454 74.0753 55.0728C73.5491 54.3283 72.6338 53.9929 71.7355 54.1493Z",
    stroke: "#7DD351",
    strokeWidth: 3.10003,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.96 44.8886C168.741 45.6258 169.972 45.5901 170.71 44.8087C171.447 44.0273 171.411 42.7962 170.63 42.0589C169.848 41.3217 168.617 41.3574 167.88 42.1388C167.143 42.9202 167.178 44.1513 167.96 44.8886Z",
    fill: "#7DD351"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.461 47.6361C175.242 48.3734 176.473 48.3376 177.21 47.5562C177.948 46.7749 177.912 45.5437 177.13 44.8065C176.349 44.0692 175.118 44.105 174.381 44.8864C173.643 45.6678 173.679 46.8989 174.461 47.6361Z",
    fill: "#7DD351"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.702 50.85C181.483 51.5873 182.714 51.5515 183.451 50.7701C184.189 49.9887 184.153 48.7576 183.371 48.0204C182.59 47.2831 181.359 47.3189 180.622 48.1003C179.884 48.8816 179.92 50.1128 180.702 50.85Z",
    fill: "#7DD351"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.644 44.0256C184.089 37.0513 171.115 32.4717 164.945 30.7678C164.325 30.5964 163.657 30.7272 163.228 31.2075C160.599 34.1519 158.253 41.3863 157.063 45.9751C156.818 46.9206 157.294 47.895 158.177 48.3117L167.709 52.8077C168.359 53.1142 168.804 53.7351 168.886 54.4492L169.562 60.3799C169.747 61.9971 171.636 62.7818 172.912 61.7711L177.52 58.1208C178.101 57.6601 178.884 57.5449 179.573 57.8189L187.126 60.8181C187.984 61.1591 188.97 60.8947 189.504 60.1408C193.463 54.5471 195.058 48.8927 195.493 45.8358C195.594 45.1183 195.248 44.4251 194.644 44.0256Z",
    stroke: "#7DD351",
    strokeWidth: 2.4639,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6223 205.489C47.6746 204.984 48.1179 203.721 47.6123 202.668C47.1067 201.616 45.8438 201.173 44.7914 201.678C43.7391 202.184 43.2958 203.447 43.8014 204.499C44.307 205.551 45.5699 205.995 46.6223 205.489Z",
    fill: "#7DD351"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9415 199.965C52.9938 199.459 53.4371 198.196 52.9315 197.144C52.4259 196.092 51.163 195.648 50.1106 196.154C49.0583 196.66 48.615 197.923 49.1206 198.975C49.6262 200.027 50.8891 200.47 51.9415 199.965Z",
    fill: "#7DD351"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6314 194.885C58.6838 194.38 59.127 193.117 58.6214 192.064C58.1159 191.012 56.8529 190.569 55.8006 191.074C54.7482 191.58 54.305 192.843 54.8106 193.895C55.3161 194.948 56.5791 195.391 57.6314 194.885Z",
    fill: "#7DD351"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1456 178.091C44.9584 186.082 35.2584 197.461 31.1268 203.056C30.7111 203.619 30.5836 204.347 30.904 204.97C32.867 208.784 39.2929 213.982 43.4848 216.977C44.3486 217.594 45.5225 217.49 46.2894 216.757L54.5639 208.837C55.128 208.298 55.9314 208.088 56.6874 208.283L62.968 209.906C64.6805 210.35 66.2128 208.738 65.6842 207.051L63.7756 200.955C63.5348 200.185 63.7229 199.344 64.2694 198.753L70.2541 192.259C70.9345 191.52 71.0502 190.418 70.4931 189.582C66.3604 183.387 61.245 179.566 58.3128 177.934C57.6245 177.552 56.7865 177.634 56.1456 178.091Z",
    stroke: "#7DD351",
    strokeWidth: 2.67765,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.949 154.744C175.975 176.199 167.817 184.82 161.291 187.375L101.168 202.962C100.151 203.227 99.2026 203.74 98.5136 204.532C91.1371 213.02 93.8806 225.078 97.4216 232.733C98.5697 235.217 101.434 236.247 104.046 235.435L155.988 219.273C172.043 213.074 181.984 197.601 184.949 190.638L237.936 55.1833C238.284 54.2936 238.458 53.3187 238.204 52.3978C237.191 48.7226 233.911 47.8828 231.091 48.0362C229.276 48.1347 227.869 49.5038 227.183 51.1864L184.949 154.744Z",
    stroke: "#7DD351",
    strokeWidth: 3.26318,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.5481 118.026C87.0923 110.957 98.0893 99.6006 127.721 102.709C142.527 104.263 151.676 107.734 157.15 111.601C162.576 115.433 164.508 119.769 164.391 122.951C164.447 125.951 162.167 130.157 156.498 133.443C150.752 136.774 141.396 139.267 126.826 138.838C97.71 137.982 87.0591 125.806 85.5351 119.057C85.5021 118.911 85.4954 118.766 85.5113 118.625C85.4932 118.429 85.5041 118.228 85.5481 118.026ZM127.312 106.604C98.4679 103.578 90.2772 114.727 89.3738 118.861C89.2667 119.352 89.7516 118.589 89.3738 118.861C88.6847 124.154 100.947 135.465 126.902 136.229C141.178 136.649 150.002 134.191 155.189 131.185C159.043 128.951 160.824 126.469 161.474 124.637C162.106 121.462 159.628 118.145 154.891 114.799C150.162 111.459 141.744 108.118 127.312 106.604Z",
    fill: "#7DD351"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1346 119.257L85.2583 138.429",
    stroke: "#7DD351",
    strokeWidth: 3.26318,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.46 125.933L161.018 145.142",
    stroke: "#7DD351",
    strokeWidth: 2.77371,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2975 129.045C89.2826 131.357 95.3903 136.355 103.94 137.856",
    stroke: "#7DD351",
    strokeWidth: 1.95792,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.943 132.806C159.958 135.117 153.85 140.115 145.301 141.616",
    stroke: "#7DD351",
    strokeWidth: 1.95792,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7268 132.478C88.7118 134.789 94.8194 139.787 103.369 141.288",
    stroke: "#7DD351",
    strokeWidth: 1.95792,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.025 136.231C160.039 138.542 153.932 143.54 145.382 145.041",
    stroke: "#7DD351",
    strokeWidth: 1.95792,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0741 136.391C88.0593 138.702 94.1669 143.701 102.716 145.202",
    stroke: "#7DD351",
    strokeWidth: 1.95792,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.964 140.8C158.979 143.112 154.095 147.457 145.545 148.958",
    stroke: "#7DD351",
    strokeWidth: 1.95792,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.261 200.109C115.633 203.752 119.57 216.735 116.503 231.355",
    stroke: "#7DD351",
    strokeWidth: 5.87374
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.124 198.84C120.92 202.04 126.43 214.438 125.191 229.324",
    stroke: "#7DD351",
    strokeWidth: 5.87374
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.901 196.435C139.693 199.262 147.471 207.642 143.506 222.868",
    stroke: "#7DD351",
    strokeWidth: 5.87374
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.909 190.809C156.233 197.743 155.58 190.809 163.167 216.506",
    stroke: "#7DD351",
    strokeWidth: 5.87374
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.84 195.051C133.825 203.806 136.327 212.999 133.961 226.623",
    stroke: "#7DD351",
    strokeWidth: 4.56846
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.848 189.417C152.833 198.173 155.335 207.365 152.969 220.989",
    stroke: "#7DD351",
    strokeWidth: 4.56846
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_653_921"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 240,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSportMarketingFilled);
export default __webpack_public_path__ + "static/media/sport-marketing-filled.5ac19cd919370d59a347acd8d62e0847.svg";
export { ForwardRef as ReactComponent };